import React from 'react';

import {Icon, Button } from 'rsuite';
import Infos from './Infos';
import Instrucao from './Instrucao';

//Componentes de roteamento
import { Link } from "react-router-dom";

import logo from './../assets/logomini.png';


export default class Nav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          show: Array(3).fill(false),
        };
        // this.close = this.close.bind(this);
        // this.open = this.open.bind(this);
      }
      close(i) {
        let aux = this.state.show.slice() 
        aux[i] = false;
        this.setState({ show: aux });
      }
      open(i) {
          console.log(this.state.show);
        let aux = this.state.show.slice() 
        aux[i] = true;
        this.setState({ show: aux });
        console.log(this.state.show);
      }

    render() {
        var mostrar = {
            'display': 'block'
        };
    
        var esconder = {
            'display': 'none'
        };
        return (
           <div id="nav" className="bkColor3">
                <div id="subnav" className>
                    <img className='logonav' src={logo} alt="logo EIC"/>
                    <Icon className='navicon' icon='home' onClick={this.open.bind(this,0)} size='2x'/>
                    <Icon className='navicon' icon='share-alt' onClick={this.open.bind(this,1)} size='2x'/>
                    <Icon className='navicon' icon='people-group' onClick={this.open.bind(this,2)} size='2x'/>
                </div>

                <div className="modal-personalizado"
                    style={this.state.show[0]? mostrar : esconder }
                >
                    <div className="containerModal modal-body bkColor3 opacidade">
                    <Instrucao
                      title={'Atenção'}
                      content={<h3>Tem certeza que desaja volta a página inicial?<br/> Você perderá seu progresso no jogo.</h3>}
                      contentButton ={
                        <Link to="/">
                          <Button className='sizeButton borColor3 Color4 button1 buttonIncial'><Icon icon='home' size='2x' /> Home</Button>
                        </Link>
                      }
                      // nav1={<Link to="/instrucao2">
                      //   <Button className='borColor1 Color3 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
                      // </Link>
                      // }
                      // nav2={
                      //   <Link to="/instrucao4">
                      //     <Button className='borColor1 Color3 button1 buttonR sizeButton'><Icon icon='caret-right' size='3x' /></Button>
                      //   </Link>
                      // }

                      button={
                        <h6 className='iconShare Color4'  onClick={this.close.bind(this,0)}><Icon className='iconShare Color4' icon='back-arrow' size='1x'/> CANCELAR</h6>
                      }

                    /> 
                    </div>
                </div>


                <div className="modal-personalizado"
                    style={this.state.show[1]? mostrar : esconder }
                >
                    <div className="containerModal modal-body bkColor3 opacidade" >
                    <Infos
                          col1={
                            <div className="col fullWidth center distributed4 fullHeight padding-top-bottom padding-shared">
                              <div className="col center ">
                                <h5 className="Color1">COMPARTILHE O JOGO CAÇA PALAVRAS</h5>                                    
                                <p className="Color3 magro">Convide amigos e familiares para jogar!</p>
                              </div>
                              <div className="row distributed4 padding-top">
                                <div className="col">
                                <div  class="fb-share-button" 
                                    data-href="http://eic.ifsc.usp.br/app/caca-palavra/" 
                                    // data-href="https://illiamw.github.io/app/caca-palavra/" 
                                    
                                >
                                    <a  
                                      target="_blank" 
                                      // href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Filliamw.github.io%2Fapp%2Fcaca-palavra%2F&amp;src=sdkpreparse" 
                                      href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Feic.ifsc.usp.br%2Fapp%2Fcaca-palavra%2F&amp;src=sdkpreparse" 
                                      className="iconShare">
                                      <Icon className='iconShare' icon='facebook-square' size='4x'/>
                                      <p className="iconShare">Facebook</p>
                                    </a>
                                  </div>
                                 
                                </div>
                                <div className="col">
                                  
                                  <a target="_blank" href="https://api.whatsapp.com/send?text=Jogue agora mesmo http://eic.ifsc.usp.br/app/caca-palavra/ ">
                                  {/* <a target="_blank" href="https://api.whatsapp.com/send?text=Jogue agora mesmo https://illiamw.github.io/app/caca-palavra/ "> */}

                                  <Icon className='iconShare' icon='whatsapp' size='4x'/><p className="iconShare">Whatsapp</p>
                                  </a>
                                </div>
                                
                              </div>
                            </div>
                          }

                          col2={
                            <div className="col fullWidth center distributed4 fullHeight bkColor3 border1 padding-top-bottom">
                              <div className="col center ">
                                <h5 className="Color1">SIGA O EIC NAS REDES SOCIAIS</h5>                              
                                <p className="Color2 magro "><a className="Color2 magro iconShare" target="_blank" href="http://eic.ifsc.usp.br/">http://eic.ifsc.usp.br/</a></p>
                              </div>
                              <div className="row distributed4 Color2 padding-top">
                                <div className="col">                  
                                  <a target="_blank" href="https://www.instagram.com/eiciencia/?hl=pt-br">
                                    <Icon className='Color2 iconShare' icon='instagram' size='4x'/><p className="Color2 iconShare">Instagram</p>
                                  </a>
                                </div>
                                
                                <div className="col">
                                  <a target="_blank" href="https://www.facebook.com/EIC.USP">
                                    <Icon className='Color2 iconShare' icon='facebook-square' size='4x'/><p className="Color2 iconShare">Facebook</p>
                                  </a>
                                </div>
                                <div className="col">
                                  <a target="_blank" href="https://www.youtube.com/channel/UCjg75EYzCSLYCcxcXOuv_-g">
                                    <Icon className='Color2 iconShare' icon='youtube-play' size='4x'/><p className="Color2 iconShare">Youtube</p>
                                  </a>
                                </div>
                                
                              </div>

                            </div>

                          }

                          volta={
                            <h6 className='iconShare'  onClick={this.close.bind(this,1)}><Icon className='iconShare' icon='back-arrow' size='1x'/> VOLTAR</h6>

                          }

                        />

                      
                    </div>
                </div>

                <div className="modal-personalizado"
                    style={this.state.show[2]? mostrar : esconder }
                >
                    <div className="containerModal modal-body bkColor3 opacidade">
                    <Infos
                      col1={
                        <div className="col fullWidth text-creditos distributed3 fullHeight padding-creditos">
                          <div className="sesson">
                            <h5 className="Color1">COORDENAÇÃO E SUPERVISÃO GERAL</h5>                                    
                            <p className="Color3 magro">Profa. Dra. Leila M. Beltramini</p>
                            <p className="Color3 magro">Profa. Dra. Nelma R. Segnini Bossolan</p>
                          </div>
                          <div className="sesson">
                            <h5 className="Color1">EDUCADORA</h5>                                    
                            <p className="Color3 magro">Ma. Gislaine Costa dos Santos</p>
                          </div>
                          <div className="sesson">
                            <h5 className="Color1">CONSULTOR DE TECNOLOGIA DA INFORMAÇÃO</h5>                                    
                            <p className="Color3 magro">Me. Claudinei Caetano de Souza</p>
                            <p className="Color3 magro">Dra. Simone Ferreira Souza</p>
                          </div>
                        </div>
                      }

                      col2={
                        <div className="col fullWidth justify distributed3 fullHeight">
                          <div className="sesson">
                            <h5 className="Color1">DESENVOLVIMENTO DO SOFTWARE</h5>                                    
                            <p className="Color3 magro">Luísa Gabriela Tupan Anastácio (versão 1.0)</p>
                            <p className="Color3 magro">Claudinei Caetano de Souza (versão 1.0)</p>
                            <p className="Color3 magro">William Luis Alves Ferreira (versão 2.0)</p>

                          </div>
                          <div className="sesson">
                            <h5 className="Color1">CONTEÚDO</h5>                                    
                            <p className="Color3 magro">Ma. Marília Faustino da Silva</p>                                  
                            <p className="Color3 magro">Ma. Gislaine Gomes da Costa</p>
                            <p className="Color3 magro">Rudison Beltramini Trevilato</p>
                          </div>
                        </div>

                      }

                      volta={
                        <h6 className='iconShare'  onClick={this.close.bind(this,2)}><Icon className='iconShare' icon='back-arrow' size='1x'/> VOLTAR</h6>

                      }

                    />  
                    </div>
                </div>

           </div>

        );
    }
}